import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Gallery from '../components/Gallery';
import SimpleMusicPlayer from '../components/SimpleMusicPlayer';
import { musicLibrary } from '../data/musicLibrary';

// ✅ Utility function for proper case
const toProperCase = (str: string) =>
  str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());

const Location: React.FC = () => {
  const { name } = useParams<{ name: string }>();

  // Pick a random song for this page instance
  const song = useMemo(() => {
    return musicLibrary[Math.floor(Math.random() * musicLibrary.length)];
  }, []);

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '10px' }}>
      
      {/* Header Row: Location Name (left) + Music Player (right) */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '12px',
          marginBottom: '16px',
        }}
      >
        <h2 style={{ margin: 0, fontSize: '26px', fontWeight: 600 }}>
          {name ? toProperCase(name) : ''}
        </h2>

        <SimpleMusicPlayer song={song} />
      </div>

      {/* Gallery */}
      <Gallery location={name || ''} />
    </div>
  );
};

export default Location;
